import { useState } from 'react'
import { Box, ButtonBase, Popover, Typography } from '@mui/material'

const MAX_ROWS = 6
const MAX_COLS = 6

export type TTableSize = {
  rows: number
  cols: number
}

export type TTableSizePickerProps = {
  anchorEl: HTMLElement | null
  onClose: () => void
  onPick: (size: TTableSize) => void
}

export const TableSizePicker = ({ anchorEl, onClose, onPick }: TTableSizePickerProps) => {
  const [hovered, setHovered] = useState<TTableSize>({ rows: 2, cols: 2 })

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Box p={1.5}>
        <Box
          display="grid"
          gridTemplateColumns={`repeat(${MAX_COLS}, 20px)`}
          gap={0.5}
          onMouseLeave={() => setHovered({ rows: 2, cols: 2 })}
        >
          {Array.from({ length: MAX_ROWS * MAX_COLS }, (_, index) => {
            const size = { rows: Math.floor(index / MAX_COLS) + 1, cols: (index % MAX_COLS) + 1 }
            const isInside = size.rows <= hovered.rows && size.cols <= hovered.cols
            return (
              <ButtonBase
                key={index}
                aria-label={`${size.cols} × ${size.rows}`}
                onMouseEnter={() => setHovered(size)}
                onFocus={() => setHovered(size)}
                onClick={() => onPick(size)}
                sx={{
                  width: 20,
                  height: 20,
                  border: 1,
                  borderRadius: 0.5,
                  borderColor: isInside ? 'primary.main' : 'divider',
                  bgcolor: isInside ? 'action.selected' : 'background.paper',
                }}
              />
            )
          })}
        </Box>
        <Typography variant="caption" color="text.secondary" display="block" mt={1} textAlign="center">
          {`${hovered.cols} × ${hovered.rows}`}
        </Typography>
      </Box>
    </Popover>
  )
}
